import { SelectOption } from '@/components/form/Select/types';

type Industry = {
  value: string;
  label: {
    fr: string;
    en: string;
    nl: string;
    es: string;
    de: string;
  };
};

const OTHER_OPTION_VALUE = 'Other';

const INDUSTRIES: Industry[] = [
  {
    value: 'Architecture & Design',
    label: {
      en: 'Architecture & Design',
      fr: 'Architecture et design',
      nl: 'Architectuur en ontwerp',
      es: 'Arquitectura y Diseño',
      de: 'Architektur & Design',
    },
  },
  {
    value: 'Business Services & Consulting',
    label: {
      en: 'Business Services & Consulting',
      fr: 'Services aux entreprises et conseil',
      nl: 'Zakelijke diensten en advies',
      es: 'Servicios Empresariales y Consultoría',
      de: 'Business Services & Consulting',
    },
  },
  {
    value: 'Construction & Engineering',
    label: {
      en: 'Construction & Engineering',
      fr: 'Construction et ingénierie',
      nl: 'Bouw en engineering',
      es: 'Construcción e Ingeniería',
      de: 'Bau und Ingenieurwesen',
    },
  },

  {
    value: 'Consumer Goods & Services',
    label: {
      en: 'Consumer Goods & Services',
      fr: 'Biens de consommation et services',
      nl: 'Consumentengoederen en diensten',
      es: 'Bienes de Consumo y Servicios',
      de: 'Konsumgüter & Dienstleistungen',
    },
  },
  {
    value: 'Design & Arts',
    label: {
      en: 'Design & Arts',
      fr: 'Design et arts',
      nl: 'Design en kunst',
      es: 'Diseño y Arte',
      de: 'Design & Kunst',
    },
  },
  {
    value: 'Education',
    label: {
      en: 'Education',
      fr: 'Éducation et formation',
      nl: 'Onderwijs en opleiding',
      es: 'Educación',
      de: 'Bildung',
    },
  },
  {
    value: 'Energy & Agriculture',
    label: {
      en: 'Energy & Agriculture',
      fr: 'Énergie et agriculture',
      nl: 'Energie en landbouw',
      es: 'Energía y Agricultura',
      de: 'Energie & Landwirtschaft',
    },
  },
  {
    value: 'Entertainment & Leisure',
    label: {
      en: 'Entertainment & Leisure',
      fr: 'Divertissement et loisirs',
      nl: 'Amusement en recreatie',
      es: 'Entretenimiento y Ocio',
      de: 'Unterhaltung & Freizeit',
    },
  },
  {
    value: 'Financial Services',
    label: {
      en: 'Financial Services',
      fr: 'Services financiers',
      nl: 'Financiële diensten',
      es: 'Servicios Financieros',
      de: 'Finanzdienstleistungen',
    },
  },
  {
    value: 'Food & Beverage',
    label: {
      en: 'Food & Beverage',
      fr: 'Alimentation et boissons',
      nl: 'Voeding en dranken',
      es: 'Alimentación y Bebidas',
      de: 'Lebensmittel & Getränke',
    },
  },
  {
    value: 'Government & Public Organizations',
    label: {
      en: 'Government & Public Organizations',
      fr: 'Gouvernement et organisations publiques',
      nl: 'Overheid en publieke organisaties',
      es: 'Gobierno y Organizaciones Públicas',
      de: 'Regierung & Öffentliche Organisationen',
    },
  },
  {
    value: 'Healthcare',
    label: {
      en: 'Healthcare',
      fr: 'Soins de santé',
      nl: 'Gezondheidszorg',
      es: 'Salud',
      de: 'Gesundheitswesen',
    },
  },
  {
    value: 'Hospitality, Travel, & Recreation',
    label: {
      en: 'Hospitality, Travel, & Recreation',
      fr: 'Hôtellerie, voyages et loisirs',
      nl: 'Hotels, reizen en vrije tijd',
      es: 'Hospitalidad, Viajes y Recreación',
      de: 'Gastgewerbe, Reisen & Freizeit',
    },
  },
  {
    value: 'Information Technology',
    label: {
      en: 'Information Technology',
      fr: "Technologie de l'information",
      nl: 'Informatietechnologie',
      es: 'Tecnología de la Información',
      de: 'Informationstechnologie',
    },
  },
  {
    value: 'Legal Services',
    label: {
      en: 'Legal Services',
      fr: 'Services juridiques',
      nl: 'Juridische diensten',
      es: 'Servicios Legales',
      de: 'Rechtsdienstleistungen',
    },
  },
  {
    value: 'Marketing & Advertising',
    label: {
      en: 'Marketing & Advertising',
      fr: 'Marketing et publicité',
      nl: 'Marketing en reclame',
      es: 'Marketing y Publicidad',
      de: 'Marketing & Werbung',
    },
  },
  {
    value: 'Media & Entertainment',
    label: {
      en: 'Media & Entertainment',
      fr: 'Médias et divertissements',
      nl: 'Media en amusement',
      es: 'Medios y Entretenimiento',
      de: 'Medien & Unterhaltung',
    },
  },
  {
    value: 'Non-Profits',
    label: {
      en: 'Non-Profits',
      fr: 'Organismes à but non lucratif',
      nl: 'Non-profitorganisaties',
      es: 'Organizaciones sin fines de lucro',
      de: 'Gemeinnützige Organisationen',
    },
  },
  {
    value: 'Professional Services',
    label: {
      en: 'Professional Services',
      fr: 'Services professionnels',
      nl: 'Professionele diensten',
      es: 'Servicios Profesionales',
      de: 'Professionelle Dienstleistungen',
    },
  },
  {
    value: 'Real Estate',
    label: {
      en: 'Real Estate',
      fr: 'Immobilier',
      nl: 'Onroerend goed',
      es: 'Bienes Raíces',
      de: 'Immobilien',
    },
  },
  {
    value: 'Retail',
    label: {
      en: 'Retail',
      fr: 'Commerce de détail',
      nl: 'Detailhandel & groothandel',
      es: 'Comercio',
      de: 'Einzelhandel',
    },
  },
  {
    value: 'Social Organizations',
    label: {
      en: 'Social Organizations',
      fr: 'Organisations sociales',
      nl: 'Maatschappelijke organisaties',
      es: 'Organizaciones Sociales',
      de: 'Soziale Organisationen',
    },
  },
  {
    value: 'Software',
    label: {
      en: 'Software',
      fr: 'Logiciels',
      nl: 'Software',
      es: 'Software',
      de: 'Software',
    },
  },
  {
    value: 'Transportation & Logistics',
    label: {
      en: 'Transportation & Logistics',
      fr: 'Transport et logistique',
      nl: 'Transport en logistiek',
      es: 'Transporte y Logística',
      de: 'Transport & Logistik',
    },
  },
  {
    value: OTHER_OPTION_VALUE,
    label: {
      en: 'Other',
      fr: 'Autres',
      nl: 'Overige',
      es: 'Otro',
      de: 'Andere',
    },
  },
];

export function getIndustryOptions(
  locale: keyof Industry['label'] = 'en'
): SelectOption[] {
  const options: SelectOption[] = INDUSTRIES.map((x) => ({
    value: x.value,
    label: x.label[locale],
  }));

  return options.sort(sortIndustryOptions);
}

function sortIndustryOptions(a: SelectOption, b: SelectOption) {
  if (a.value === OTHER_OPTION_VALUE) {
    return 1;
  }
  if (b.value === OTHER_OPTION_VALUE) {
    return -1;
  }

  return a.label.localeCompare(b.label);
}
